import { getMyTaskList, getServiceStatusList, getServiceWatingList, deleteService, getMainCompanies } from '../store/api/Services';
import { useEffect, useState, useRef, Fragment } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Loader from 'react-loader-spinner'
import { Button, Col, Row } from 'react-bootstrap';
import { CardList, EyeFill, EyeSlashFill, FileEarmarkExcelFill, List, Printer, Reply, Search } from 'react-bootstrap-icons';
import DatePicker from 'react-datepicker2';
import momentJalaali from "moment-jalali";
import "react-datepicker2/src/styles/style.css";
import { getAllProvinces, getCityList } from '../store/api/LocationAPI';
import { setSelectStaffPopup } from "../store/api/Services";
import { getPageFieldList, getUserList } from '../store/api/Users';
import ModalSelectStaff from '../../Components/Modals/ModalSelectStaff';
import { useForm } from 'react-hook-form';
import { InfoTypes, exportToExcel, getSettingBoolValue, getSettingNumberValue, getSettingValue, keyIsLetterOrNumber, setDialog, useIsMobileApp } from '../../store/api/CommonFunctions';
import BihamtaTable from '../../Components/BihamtaTable';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { faBroom, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BihamtaMultiSelect from "../../Components/BihamtaMultiSelect";
import { getExtAttrSettingsForSearch, getSystemSettings } from '../store/api/SystemSettingsAPI';
import ModalReferDocument from '../../Components/Modals/ModalReferDocument';
import { getStageList } from '../../Office/store/api/FlowAPI';
//import { getAllGuaranteeHolders } from '../store/api/GuaranteeApi';
//import { getAllProductMainGroups, getAllProductTypes, getProductGroups } from '../store/api/GetAllProduct';
import { getBaseInfoList } from '../../BaseInfo/store/api/BaseInfoApi';
import { searchProductBug } from '../store/api/TaskDetailsApi';
import ModalSelectCustomer from '../../Components/Modals/ModalSelectCustomer';
import ModalProducts from '../../Components/Modals/ModalProducts';


const MyTasks = () => {
  const frmFilters = useRef();
  const [pending, setPending] = useState(false);
  const { handleSubmit, register } = useForm();
  const [showFilter, setShowFilter] = useState(true);
  const history = useHistory();
  const isMobile = useIsMobileApp();
  const [stageList, setStageList] = useState(null);
  const [mainCompanies, setMainCompanies] = useState([]);
  const selectedStatusList = useRef([]);
  const selectedPhaseList = useRef([]);
  const dispatch = useDispatch();
  const settingNames = ['ProductGrouppingType', "CustomerInServiceSearchIsSelective", "ProductInServiceSearchIsSelective"];
  const [popReferDoc, setReferDocPop] = useState({ show: false });
  const [popProduct, setPopProduct] = useState({ show: false });
  const [popCustomer, setPopCustomer] = useState({ show: false });
  const [popStaff, setPopStaff] = useState({ show: false });
  const [considerDescList, setConsiderDescList] = useState(null);
  const { serviceStatusList, systemSettings, serviceExtraAttrSettings, provinceList, cityList, filterData, fieldList, productBugs, usersList } = useSelector(state => {
    return {
      productBugs: state.ProductReducer.productBugList?.Data,
      serviceStatusList: state.service.serviceStatusList,
      systemSettings: state.SystemSettingsReducer.systemSettings,
      serviceExtraAttrSettings: state.SystemSettingsReducer.serviceExtraAttrSettingsForSearch,
      provinceList: state.locationDataReducer.provinceList,
      cityList: state.locationDataReducer.cityList,
      filterData: state.service.searchServiceFilters,
      fieldList: state.UserReducer.pageFieldList,
      usersList: state.UserReducer.userList,
    }
  });
  const extAttrList = serviceExtraAttrSettings?.filter?.(s => s.SettingName.includes("Services_ExtAttr")) ?? [];
  const cmbAttrList = serviceExtraAttrSettings?.filter?.(s => s.SettingName.includes("Services_ComboBoxExtAttr")) ?? [];
   const chkAttrList = serviceExtraAttrSettings?.filter?.(s => s.SettingName.includes("Services_CheckBoxExtAttr")) ?? [];
  const [dateFilters, setDateFilters] = useState({
    FirstContactDate: filterData?.FirstContactDate,
    ContactDateTo: filterData?.ContactDateTo,
    ServiceDeadline: filterData?.ServiceDeadline,
    ServiceDeadlineTo: filterData?.ServiceDeadlineTo
  });
  const [selectedStaff, setStaffData] = useState({
    ID: filterData?.StaffID,
    LastName: filterData?.StaffName
  });
  // const [selectedProduct, setSelectedProduct] = useState({
  //   ProductID: filterData?.ProductID,
  //   HolderName: filterData?.HolderName,
  //   ProductName: filterData?.ProductName,
  //   ProductModel: filterData?.ProductModel
  // });
  const [selectedCustomers, setSelectedCustomers] = useState([
    ...(filterData?.SelectedCustomers ?? [])
  ]);
  const [selectedProducts, setSelectedProducts] = useState([...(filterData?.SelectedProducts ?? [])]);
  const productText = selectedProducts.map(p => [p?.HolderName, p?.ProductName, p?.ProductModel].filter(p => p?.length > 0).join("-")).join('، ');
  const pgType = getSettingNumberValue(systemSettings, "ProductGrouppingType", "1");
  const custIsSelective = getSettingBoolValue(systemSettings, "CustomerInServiceSearchIsSelective");
  const productIsSelective = getSettingBoolValue(systemSettings, "ProductInServiceSearchIsSelective");

  const tableCols = [
    { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
    { colTitle: "نوع پذیرش", colName: "ServiceTypePersianText" },
    { colTitle: "شماره پذیرش", colName: "InvoiceNumber" },
    { colTitle: "تاریخ پذیرش", colName: "PFirstContactDate" },
    { colTitle: "مارک محصول", colName: "HolderName", showCondition: () => pgType === 0 },
    { colTitle: (pgType === 1 ? "نام" : "نوع") + " محصول", colName: "ProductName", showInMobile: true },
    { colTitle: "مدل محصول", colName: "ProductModel", showInMobile: true },
    { colTitle: "شماره سریال", colName: "SerialNumber" },
    { colTitle: "کد مشتری", colName: "CustomerCode" },
    { colTitle: "کداشتراک", colName: "CustomerSubscriptionCode" },
    { colTitle: "نام مشتری", colName: "CustomerName", showInMobile: true },
    { colTitle: "موبایل مشتری", colName: "CustomerMobile" },
    { colTitle: "تلفن مشتری", colName: "CustomerPhone" },
    { colTitle: "نشانی مشتری", colName: "ServiceAddress", colType: "string", maxTextLength: 110, hasTooltip: true },
    { colTitle: "تکنسین اعزامی", colName: "StaffName" },
    { colTitle: "وضعیت سرویس", colName: "Status" }
  ]
  const tableRowButtons = [
    {
      title: "نمایش سرویس", type: "show", className: "group-Btn-smalll btn-success", onclick: showService, showCondition: () => isMobile,
    },
    { title: "ارجاع به کاربر", type: "common", className: "group-Btn-smalll", onclick: showDocRefer, icon: <Reply size={19} className='rowBtn' color='blue' />, tooltip: "ارجاع به کاربر" },
    {
      title: "حذف سرویس", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
        dispatch(setDialog({
          status: 'show',
          arrayBtn: ['yes', 'no'],
          dialogTitle: 'حذف سرویس',
          dialogText: 'آیا از حذف مطمئن هستید؟',
          okOperation: deleteService(item.ServiceType, item.ServiceID, () => dispatch(getMyTaskList(filterData)))
        }))
      }
    }

  ]
  function checkFieldPermission(fieldName, actionType) {
    let result = true;
    let field = fieldList?.find(f => f.PageName === "SearchService" && f.Name === fieldName);
    if (actionType === "Read" && field) {
      result = field.IsRead === true;
    }
    if (actionType === "Edit" && field) {
      result = field.IsUpdate === false;
    }
    return result;
  }
  function onServiceStatusChanged(item) {
    if (!selectedStatusList.current) {
      selectedStatusList.current = [];
    }
    const splited = item.value.split(",");
    if (item.checked) {
      if (!selectedStatusList.current.includes(splited)) {

        selectedStatusList.current.push(...splited);
      }
    }
    else {
      selectedStatusList.current = selectedStatusList.current.filter(a => !splited.includes(a));
    }
  }
  function onServicePhaseChanged(item) {
    if (!selectedPhaseList.current) {
      selectedPhaseList.current = [];
    }
    const splited = item.value.split(",");
    if (item.checked) {
      if (!selectedPhaseList.current.includes(splited)) {

        selectedPhaseList.current.push(...splited);
      }
    }
    else {
      selectedPhaseList.current = selectedPhaseList.current.filter(a => !splited.includes(a));
    }
  }
  const search = (data) => {
    data.Skip = 0;
    if (!data.Take) {
      data.Take = 10;
    }
    if (selectedStaff?.ID) {
      data.StaffID = selectedStaff.ID;
      data.StaffName = selectedStaff.LastName;
    }
    if (custIsSelective && Array.isArray(selectedCustomers) && selectedCustomers.length > 0) {
      // data.CustomerID = selectedCustomer.ID;
      // data.CustomerName = selectedCustomer.Name;
      data.CustomerIDs = selectedCustomers.map(c => c.ID);
      data.SelectedCustomers = selectedCustomers.map(c => ({ ID: c.ID, Name: c.Name }));
    }
    // if (selectedProduct?.ProductID) {
    //   data.ProductID = selectedProduct.ProductID;
    //   data.HolderName = selectedProduct.HolderName;
    //   data.ProductName = selectedProduct.ProductName;
    //   data.ProductModel = selectedProduct.ProductModel;
    // }
    if (productIsSelective) {
      data.ProductIDs = selectedProducts.map(s => s.ProductID);
      data.SelectedProducts = [...selectedProducts];
    }
    if (document.getElementsByName("dateTo")[0]?.value !== "") {
      data.ContactDateTo = dateFilters.ContactDateTo;
    }
    if (document.getElementsByName("deadlineFrom")[0]?.value !== "") {
      data.ServiceDeadline = dateFilters.ServiceDeadline;
    }
    if (document.getElementsByName("deadlineTo")[0]?.value !== "") {
      data.ServiceDeadlineTo = dateFilters.ServiceDeadlineTo;
    }
    if (document.getElementsByName("dateFrom")[0]?.value !== "") {
      data.FirstContactDate = dateFilters.FirstContactDate;
    }
    if (document.getElementsByName("dateTo")[0]?.value !== "") {
      data.ContactDateTo = dateFilters.ContactDateTo;
    }
    if (document.getElementsByName("lastRefDateFrom")[0]?.value !== "") {
      data.LastRefDateFrom = dateFilters.LastRefDateFrom;
    }
    if (document.getElementsByName("lastRefDateTo")[0]?.value !== "") {
      data.LastRefDateTo = dateFilters.LastRefDateTo;
    }
    if (document.getElementsByName("archiveDateFrom")[0]?.value !== "") {
      data.ArchiveDateFrom = dateFilters.ArchiveDateFrom;
    }
    if (document.getElementsByName("archiveDateTo")[0]?.value !== "") {
      data.ArchiveDateTo = dateFilters.ArchiveDateTo;
    }
    if (document.getElementsByName("sendDateFrom")[0]?.value !== "") {
      data.SendDateFrom = dateFilters.SendDateFrom;
    }
    if (document.getElementsByName("sendDateTo")[0]?.value !== "") {
      data.SendDateTo = dateFilters.SendDateTo;
    }

    if (!checkFieldPermission("IsArchive", "Read")) {
      data.IsArchive = false;
    }
    data.StatusList = selectedStatusList.current;
    data.StatusPhaseList = selectedPhaseList.current;
    dispatch(getMyTaskList(data));
  }
  function getWatingList() {
    dispatch(getServiceWatingList());
  }
  const loadCityList = (provinceID) => {
    //searchData.current.ProvinceID = provinceID;
    dispatch(getCityList(provinceID));
  }
  function showHideFilter(hide) {
    const divFilters = document.getElementById("divFilters");
    if (hide) {
      divFilters.classList.add("hiddenRow");
      setShowFilter(false);
    }
    else {
      divFilters.classList.remove("hiddenRow");
      setShowFilter(true);
    }
  }
  function showDocRefer(row) {
    setReferDocPop({ show: true, documentHardCode: row.ServiceType, documentID: row.ServiceID, stageID: row.StageID });
  }

  function showService(row) {
    history.push(`/Services/Service/${row.ServiceID}/${row.ServiceType}`, null);
  }
  function toExcel() {
    const url = "ReceptionTasksApi/GetMyTasks";
    const searchArgs = { ...filterData };
    searchArgs.Skip = 0;
    searchArgs.Take = 0;
    setPending(true);
    exportToExcel("SearchServices", searchArgs, url, "post", tableCols, () => setPending(false));
  }
  function printReport(e) {
    const searchArgs = { ...filterData };
    history.push({
      pathname: `/PrintViewer/SearchService/${e.ctrlKey}`,
      state: {
        dataUrl: `ReceptionTasksApi/GetMyTasks`,
        method: "post",
        fetchBody: JSON.stringify(searchArgs)
      }
    });
  }
  function clearFilters() {
    frmFilters.current.reset();
    setSelectedCustomers([]);
    setSelectedProducts([]);
    setDateFilters({
      FirstContactDate: null,
      ContactDateTo: null,
      ServiceDeadline: null,
      ServiceDeadlineTo: null
    });
    setStaffData(null);
    dispatch(getMyTaskList({ Take: 10, Skip: 0 }));
  }
  function showModalProduct(e) {
    if (e.key) {
      if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
        return;
      }
      e.preventDefault();
    }
    const setData = (data) => {
      setSelectedProducts(data);
    }
    setPopProduct({ show: true, value: e.key, multiSelect: true, setProductData: setData });
  }
  function showModalCustomer(e) {
    if (e.key) {
      if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
        return;
      }
      e.preventDefault();
    }
    const onSelectCustomer = (data) => {
      setSelectedCustomers(data)

    }
    setPopCustomer({ show: true, value: e.key, invoiceCustomers: false, justForSelect: true, multiSelect: true, setCustomerData: onSelectCustomer });
  }
  function showModalStaff(e) {
    setPopStaff({ show: true, onSelect: setStaffData });
  }
  useEffect(() => {
    document.body.classList = "notMain";
    document.title = "بی همتا-خدمات";
    async function fetchData() {
      dispatch(getAllProvinces());
      dispatch(getServiceStatusList());
      dispatch(getSystemSettings(settingNames));
      dispatch(getStageList("service", setStageList));
      dispatch(getExtAttrSettingsForSearch());
      dispatch(searchProductBug({ Take: 1000 }));
      getMainCompanies(setMainCompanies);
      getBaseInfoList(InfoTypes.ServiceConsiderDesc, setConsiderDescList);
      dispatch(getPageFieldList(""));
      dispatch(getUserList(''));
    }
    fetchData();

  }, []);
  return (
    <div className="container-fluid mt-1" style={{ minHeight: '80vh' }}>
      <br />
      <div className="card">
        <div className="card-header headerStyle">
          <FontAwesomeIcon icon={faSearch} size='lg' />&nbsp;
          جستجوی کارها</div>
        <div className="card-body bodyStyle">
          <ModalReferDocument popData={popReferDoc} setPopData={setReferDocPop} />
          <ModalSelectCustomer popData={popCustomer} setCustomerPopup={setPopCustomer} />
          <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={pgType} hideNewProduct={true} />
          <form onSubmit={handleSubmit(search)} ref={frmFilters}>
            <Row id="divFilters" className="rowBorder" >
              <div className="rowTitle">
                فیلترهای جستجو
                &nbsp;
                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
              </div>
              <ModalSelectStaff setPopSelectStaff={setPopStaff} popData={popStaff} />
              <Col md={2} xs={6} className="form-group" >
                <select className='tableRowInput' defaultValue={filterData?.ServiceType ?? ""} name="ServiceType" ref={register({})}>
                  <option value="">انتخاب نوع سرویس</option>
                  <option value="repair">تعمیر</option>
                  <option value="install">نصب</option>
                </select>
              </Col>
              <Col md={2} xs={6} className="form-group" >
                <select className='tableRowInput' defaultValue={filterData?.ReceptionInAgent ?? ""} name="ReceptionInAgent" ref={register({})}>
                  <option value="">انتخاب نوع پذیرش</option>
                  <option value={false}>پذیرش در دفتر مرکزی</option>
                  <option value={true}>پذیرش در نمایندگی</option>
                </select>
              </Col>
              <Col md={2} xs={6} className='form-group'>
                <input placeholder='َشماره سرویس' type='number' lang='en' className='tableRowInput' min={0} name="InvoiceNumber" ref={register({})} defaultValue={filterData?.InvoiceNumber ?? ""} />
              </Col>
              {!isMobile &&
                <Col md={2} xs={6} className='form-group'>
                  <input placeholder='نام نمایندگی' type='text' lang='en' className='tableRowInput' min={0} name="AgencyName" ref={register({})} defaultValue={filterData?.AgencyName ?? ""} />
                </Col>
              }
              {productIsSelective ?
                <Col md={2} xs={6} className='form-group'>
                  <input placeholder="مشخصات محصول" type='text' className='tableRowInput' value={productText ?? ""} onKeyDown={showModalProduct} readOnly />
                  <Button className='btn-input-tiny' onClick={showModalProduct} style={{ top: 2 }}><List size={16} /></Button>
                </Col> :
                <>
                  {pgType === 0 &&
                    <Col md={2} xs={6} className='form-group'>
                      <input placeholder='مارک محصول' type='text' lang='en' className='tableRowInput' min={0} name="ProductHolder" ref={register({})} defaultValue={filterData?.ProductHolder ?? ""} />
                    </Col>
                  }
                  {pgType === 1 ?
                    <Col md={2} xs={6} className='form-group'>
                      <input placeholder='نام محصول' type='text' lang='en' className='tableRowInput' min={0} name="ProductName" ref={register({})} defaultValue={filterData?.ProductName ?? ""} />
                    </Col> :
                    <Col md={2} xs={6} className='form-group'>
                      <input placeholder='نوع محصول' type='text' lang='en' className='tableRowInput' min={0} name="ProductType" ref={register({})} defaultValue={filterData?.ProductType ?? ""} />
                    </Col>}
                  <Col md={2} xs={6} className='form-group'>
                    <input placeholder='مدل محصول' type='text' lang='en' className='tableRowInput' min={0} name="ProductModel" ref={register({})} defaultValue={filterData?.ProductModel ?? ""} />
                  </Col>
                </>}
              <Col md={2} xs={6} className='form-group'>
                <input placeholder='سریال محصول' type='text' lang='en' className='tableRowInput' name="SerialNumber" ref={register({})} defaultValue={filterData?.SerialNumber ?? ""} style={{ fontFamily: "Dark-Sans", fontSize: "10.5px" }} />
              </Col>
              <Col md={2} xs={6} className='form-group'>
                <input placeholder='شماره گارانتی' type='text' lang='en' className='tableRowInput' name="GuaranteeCardNo" ref={register({})} defaultValue={filterData?.GuaranteeCardNo ?? ""} style={{ fontFamily: "Dark-Sans", fontSize: "10.5px" }} />
              </Col>

              <Col md={1} xs={6} className="form-group">
                <DatePicker placeholder='تاریخ پذیرش از' isGregorian={false} timePicker={false} className="tableRowInput mt-0" name="dateFrom"
                  onChange={value => setDateFilters({ ...dateFilters, FirstContactDate: value.local("en").format("YYYY-MM-DD") })}
                  value={dateFilters?.FirstContactDate ? momentJalaali(dateFilters.FirstContactDate) : null} />
              </Col>
              <Col md={1} xs={6} className="form-group" >
                <DatePicker placeholder='تاریخ پذیرش تا' isGregorian={false} timePicker={false} className="tableRowInput mt-0" name="dateTo"
                  onChange={value => setDateFilters({ ...dateFilters, ContactDateTo: value.local("en").format("YYYY-MM-DD") })}
                  value={dateFilters?.ContactDateTo ? momentJalaali(dateFilters.ContactDateTo) : null} />
              </Col>
              {!isMobile &&
                <Fragment>
                  <Col md={1} xs={6} className="form-group">
                    <DatePicker placeholder='تاریخ موعد از' isGregorian={false} timePicker={false} className="tableRowInput mt-0" name="deadlineFrom"
                      onChange={value => setDateFilters({ ...dateFilters, ServiceDeadline: value.local("en").format("YYYY-MM-DD") })}
                      value={dateFilters?.ServiceDeadline ? momentJalaali(dateFilters.ServiceDeadline) : null} />
                  </Col>
                  <Col md={1} xs={6} className="form-group">
                    <DatePicker placeholder='تاریخ موعد تا' isGregorian={false} timePicker={false} className="tableRowInput mt-0" name="deadlineTo"
                      onChange={value => setDateFilters({ ...dateFilters, ServiceDeadlineTo: value.local("en").format("YYYY-MM-DD") })}
                      value={dateFilters?.ServiceDeadlineTo ? momentJalaali(dateFilters.ServiceDeadlineTo) : null} />
                  </Col>
                </Fragment>
              }
              <Col md={1} xs={6} className="form-group">
                <DatePicker placeholder='تاریخ اعزام از' isGregorian={false} timePicker={false} className="tableRowInput mt-0" name="sendDateFrom"
                  onChange={value => setDateFilters({ ...dateFilters, SendDateFrom: value.local("en").format("YYYY-MM-DD") })}
                  value={dateFilters?.SendDateFrom ? momentJalaali(dateFilters.SendDateFrom) : null} />
              </Col>
              <Col md={1} xs={6} className="form-group">
                <DatePicker placeholder='تاریخ اعزام تا' isGregorian={false} timePicker={false} className="tableRowInput mt-0" name="sendDateTo"
                  onChange={value => setDateFilters({ ...dateFilters, SendDateTo: value.local("en").format("YYYY-MM-DD") })}
                  value={dateFilters?.SendDateTo ? momentJalaali(dateFilters.SendDateTo) : null} />
              </Col>
              <Col md={1} xs={6} className="form-group">
                <DatePicker placeholder='تاریخ انجام از' isGregorian={false} timePicker={false} className="tableRowInput mt-0" name="lastRefDateFrom"
                  onChange={value => setDateFilters({ ...dateFilters, LastRefDateFrom: value.local("en").format("YYYY-MM-DD") })}
                  value={dateFilters?.LastRefDateFrom ? momentJalaali(dateFilters.LastRefDateFrom) : null} />
              </Col>
              <Col md={1} xs={6} className="form-group">
                <DatePicker placeholder='تاریخ انجام تا' isGregorian={false} timePicker={false} className="tableRowInput mt-0" name="lastRefDateTo"
                  onChange={value => setDateFilters({ ...dateFilters, LastRefDateTo: value.local("en").format("YYYY-MM-DD") })}
                  value={dateFilters?.LastRefDateTo ? momentJalaali(dateFilters.LastRefDateTo) : null} />
              </Col>
              {!isMobile &&
                <Fragment>
                  <Col md={1} className="form-group" style={{ paddingLeft: !isMobile ? "2px" : "0.75rem" }}>
                    <DatePicker placeholder='تاریخ بایگانی از' isGregorian={false} timePicker={false} className="tableRowInput mt-0" name="archiveDateFrom"
                      onChange={value => setDateFilters({ ...dateFilters, ArchiveDateFrom: value.local("en").format("YYYY-MM-DD") })}
                      value={dateFilters?.ArchiveDateFrom ? momentJalaali(dateFilters.ArchiveDateFrom) : null} />
                  </Col>
                  <Col md={1} className="form-group" style={{ paddingRight: !isMobile ? "2px" : "0.75rem" }}>
                    <DatePicker placeholder='تاریخ بایگانی تا' isGregorian={false} timePicker={false} className="tableRowInput mt-0" name="archiveDateTo"
                      onChange={value => setDateFilters({ ...dateFilters, ArchiveDateTo: value.local("en").format("YYYY-MM-DD") })}
                      value={dateFilters?.ArchiveDateTo ? momentJalaali(dateFilters.ArchiveDateTo) : null} />
                  </Col>
                </Fragment>
              }
              {custIsSelective ?
                <Col md={2} xs={6} className='form-group'>
                  <input placeholder='نام مشتری' type='text' className='tableRowInput'
                    value={Array.isArray(selectedCustomers) && selectedCustomers.length > 0 ? selectedCustomers.map(c => c.Name).join('، ') : ""}
                    onKeyDown={showModalCustomer} readOnly
                  />
                  <Button className='btn-input-tiny' onClick={showModalCustomer} style={{ top: 2 }}><List size={16} /></Button>
                </Col> :
                <>
                  <Col md={2} xs={6} className='form-group'>
                    <input placeholder='کد مشتری' className='tableRowInput' type='text' name="CustomerCode" ref={register({})} defaultValue={filterData?.CustomerCode ?? ""} />
                  </Col>
                  <Col md={2} xs={6} className='form-group'>
                    <input placeholder='نام مشتری' className='tableRowInput' type='text' name="CustomerName" ref={register({})} defaultValue={filterData?.CustomerName ?? ""} />
                  </Col>
                  <Col md={2} xs={6} className='form-group'>
                    <input placeholder='موبایل مشتری' className='tableRowInput' type='text' name="CustomerMobile" ref={register({})} defaultValue={filterData?.CustomerMobile ?? ""} />
                  </Col>
                  <Col md={2} xs={6} className='form-group'>
                    <input placeholder='تلفن مشتری' className='tableRowInput' type='text' name="CustomerPhone" ref={register({})} defaultValue={filterData?.CustomerPhone ?? ""} />
                  </Col>
                  <Col md={2} xs={6} className='form-group'>
                    <input placeholder='کد ملی مشتری' className='tableRowInput' type='text' name="CustomerNationalCode" ref={register({})} defaultValue={filterData?.CustomerNationalCode ?? ""} />
                  </Col>
                  <Col md={2} xs={6} className='form-group'>
                    <input placeholder='کد اشتراک مشتری' className='tableRowInput' type='text' name="CustomerSubscriptionCode" ref={register({})} defaultValue={filterData?.CustomerSubscriptionCode ?? ""} />
                  </Col>
                </>
              }
              <Col md={2} xs={6} className='form-group'>
                <input placeholder='نشانی مشتری' className='tableRowInput' type='text' name="ServiceAddress" ref={register({})} defaultValue={filterData?.ServiceAddress ?? ""} />
              </Col>
              <Col md={2} xs={6} className='form-group'>
                <input placeholder='توضیحات' className='tableRowInput' type='text' name="Description" ref={register({})} defaultValue={filterData?.Description ?? ""} />
              </Col>
              {!isMobile &&
                <Fragment>
                  <Col md={2} xs={6} className='form-group'>
                    <select className="tableRowInput" onChange={e => loadCityList(e.target.value)} name="ProvinceID" ref={register({})} defaultValue={filterData?.ProvinceID ?? ""} >
                      <option value="">انتخاب استان</option>
                      {provinceList && Array.isArray(provinceList) && provinceList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                    </select>
                  </Col>
                  <Col md={2} xs={6} className='form-group'>
                    <select className="tableRowInput" name="CityID" ref={register({})} defaultValue={filterData?.CityID ?? ""}>
                      <option value="">انتخاب شهر</option>
                      {cityList && Array.isArray(cityList) && cityList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                    </select>
                  </Col>
                </Fragment>
              }
              <Col md={2} xs={6} className="form-group" >
                <select className='tableRowInput' defaultValue={checkFieldPermission("IsArchive", "Read") ? filterData?.IsArchive : false} disabled={!checkFieldPermission("IsArchive", "Read")}
                  name="IsArchive" ref={register({})}>
                  {checkFieldPermission("IsArchive", "Read") && <option value="">انتخاب وضعیت بایگانی</option>}
                  {checkFieldPermission("IsArchive", "Read") && <option value={true}>بایگانی شده</option>}
                  <option value={false}>بایگانی نشده</option>
                </select>
              </Col>
              <Col md={2} xs={6} className='form-group'>
                {serviceStatusList === "PENDING" &&
                  <div className='tableRowInput col-md-3'>
                    <Loader type="BallTriangle" color="#bb1370" height={22} width={22} style={{ display: "inline-block" }} />
                    <span style={{ color: "#817d7f" }}>&nbsp;در حال بارگذاری فهرست</span>
                  </div>
                }
                {serviceStatusList && Array.isArray(serviceStatusList) &&
                  <BihamtaMultiSelect className="tableRowInput mt-0" placeholder="انتخاب وضعیت سرویس" dataSource={serviceStatusList} valueItem="ID" displayItem="Status" onItemCheckChanged={onServiceStatusChanged} defaultCheckedList={filterData?.StatusList} />
                }
              </Col>
              <Col md={2} xs={6} className='form-group'>
                <BihamtaMultiSelect className="tableRowInput mt-0" placeholder="انتخاب مرحله سرویس" dataSource={stageList} valueItem="ID" displayItem="StageName" onItemCheckChanged={onServicePhaseChanged} defaultCheckedList={filterData?.StatusPhaseList} />
              </Col>
              {!isMobile &&
                <Col md={2} xs={6} className='form-group'>
                  <select className='tableRowInput' name='ShowSwapped' ref={register({})} defaultValue={filterData?.ShowSwapped ?? false}>
                    <option value={false}>وضعیت جایگزینی</option>
                    <option value={true}>نمایش سرویس های جایگزین شده</option>
                  </select>
                </Col>
              }
              <Col md={2} xs={6} className='form-group'>
                <input className='tableRowInput' name="NewProductSerial" ref={register({})} placeholder='سریال جایگزین' defaultValue={filterData?.NewProductSerial ?? ""} />
              </Col>
              <Col md={2} xs={6} className='form-group'>
                <input placeholder='نام تکنسین اعزامی' type="text" className='tableRowInput' readOnly value={selectedStaff?.LastName ?? ""} />
                <Button className='btn-input-tiny' style={{ top: "2px" }} onClick={showModalStaff}><List size={17} /></Button>
              </Col>
              <Col md={2} xs={6} className='form-group'>
                {usersList === "PENDING" &&
                  <div className='tableRowInput col-md-3'>
                    <Loader type="BallTriangle" color="#bb1370" height={22} width={22} style={{ display: "inline-block" }} />
                    <span style={{ color: "#817d7f" }}>&nbsp;در حال بارگذاری فهرست</span>
                  </div>
                }
                {Array.isArray(usersList) &&
                  <select className="tableRowInput" name="CreateByID" ref={register({})} defaultValue={filterData?.CreateByID ?? ""}>
                    <option value="">ثبت کننده</option>
                    {usersList.map((item, i) => { return (<option key={i} value={item.ID}>{item.Name}</option>) })}
                  </select>
                }
              </Col>
              <Col md={2} xs={6} className='form-group'>
                {usersList === "PENDING" &&
                  <div className='tableRowInput col-md-3'>
                    <Loader type="BallTriangle" color="#bb1370" height={22} width={22} style={{ display: "inline-block" }} />
                    <span style={{ color: "#817d7f" }}>&nbsp;در حال بارگذاری فهرست</span>
                  </div>
                }
                {Array.isArray(usersList) &&
                  <select className="tableRowInput" name="UpdateByID" ref={register({})} defaultValue={filterData?.UpdateByID ?? ""}>
                    <option value="">ویرایش کننده</option>
                    {usersList.map((item, i) => { return (<option key={i} value={item.ID}>{item.Name}</option>) })}
                  </select>
                }
              </Col>

              {!isMobile &&
                <Col md={2} xs={6} className='form-group'>
                  {mainCompanies === "PENDING" &&
                    <div className="tableRowInput" style={{ width: "100%" }}>
                      <Loader type="BallTriangle" color="#bb1370" width={20} height={20} style={{ display: "inline-block", mmarginRight: "2px" }} /> &nbsp;
                      <label style={{ marginTop: "5px" }}>در حال بارگذاری شرکت های مادر</label>
                    </div>}
                  {mainCompanies?.Data && Array.isArray(mainCompanies.Data) &&
                    <select className="tableRowInput" name="MainCompanyID" ref={register({})} defaultValue={filterData?.MainCompanyID ?? 0} >
                      <option value="">شرکت مادر را انتخاب کنید</option>
                      {mainCompanies.Data.map((mc, i) => <option key={i} value={mc.ID}>{mc.Name}</option>)}
                    </select>
                  }
                </Col>}
              {!isMobile && extAttrList.length > 0 &&
                extAttrList.map((item, i) =>
                  <div key={'Ext' + i} className="form-group col-md-2">
                    <input className="tableRowInput" placeholder={item.SettingValue} name={item.SettingName.replace("Services_", "").replace("_Title", "")} ref={register({})} type="text"
                      defaultValue={filterData ? (filterData[item.SettingName.replace("Services_", "").replace("_Title", "")] ?? '') : ""} />
                  </div>
                )
              }
              {!isMobile && cmbAttrList.length > 0 && cmbAttrList.filter(s => s.SettingName.includes('_Title')).map((item, i) =>
                <div key={i} className="form-group col-md-2">
                  <select className="tableRowInput" ref={register({})} name={item.SettingName.replace("Services_", "").replace("_Title", "")} defaultValue={filterData ? filterData[item.SettingName.replace("Services_", "").replace("_Title", "")] : ''}>
                    <option value=''>انتخاب {item.SettingValue}</option>
                    {cmbAttrList.find(s => s.SettingName === item.SettingName.replace("_Title", "") + '_Items').SettingValue &&
                      cmbAttrList.find(s => s.SettingName === item.SettingName.replace("_Title", "") + '_Items').SettingValue.split("|").map((item, i) => { return (<option key={i} value={item}>{item}</option>) })
                    }
                  </select>
                </div>
              )
              }
              {!isMobile && chkAttrList.length > 0 && chkAttrList.filter(s => s.SettingName.includes('_Title')).map((item, i) =>
                <div key={i} className="form-group col-md-2">
                  <select className="tableRowInput" ref={register({})} name={item.SettingName.replace("Services_", "").replace("_Title", "")} 
                  defaultValue={filterData ? filterData[item.SettingName.replace("Services_", "").replace("_Title", "")] : ''}>
                    <option value=''>انتخاب {item.SettingValue}</option>
                    <option value={false}>خیر</option>
                    <option value={true}>بله</option>
                  </select>
                </div>
              )
              }              
              <Col md={2} xs={6} className='form-group'>
                {considerDescList?.Data ?
                  <select className="tableRowInput" defaultValue={filterData?.ConsiderDescriptionID ?? ""} name="ConsiderDescriptionID" ref={register()}>
                    <option value="">انتخاب شرح رسیدگی</option>
                    {considerDescList.Data.map((desc, i) => <option key={i} value={desc.ID}>{desc.InfoName}</option>)}
                  </select> :
                  <div className='tableRowInput'>
                    <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;<span style={{ color: "gray" }}>در حال بارگذاری فهرست </span>
                  </div>
                }
              </Col>
              <Col md={2} xs={6} className='form-group'>
                {Array.isArray(productBugs ?? "") ?
                  <select className='scThin tableRowInput' defaultValue={filterData?.BugID ?? ""} name="BugID" ref={register()}>
                    <option value="">انتخاب ایراد</option>
                    {productBugs.map((bug, i) => <option key={i} value={bug.ID}>{bug.Bug + ` (${bug.Code})`}</option>)}
                  </select> :
                  <div className='tableRowInput'>
                    <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;<span style={{ color: "gray" }}>در حال بارگذاری فهرست</span>
                  </div>
                }
              </Col>
              <Col md={2} xs={6} className='form-group'>
                <select className='tableRowInput' name="StoppedInStatus" ref={register({})} defaultValue={filterData?.StoppedInStatus ?? ""}>
                  <option value="">وضعیت توقف</option>
                  <option value={true}>توقف</option>
                  <option value={false}>ادامه کار</option>
                </select>
              </Col>
              <Col md={2} xs={6} className='form-group'>
                <select className='tableRowInput' name="HasDoneVerification" ref={register({})} defaultValue={filterData?.HasDoneVerification ?? ""}>
                  <option value="">وضعیت تایید انجام</option>
                  <option value={true}>انجام تایید شده</option>
                  <option value={false}>انجام تایید نشده</option>
                </select>
              </Col>
              {/* استفاده خاصی ندارد و تنها فیلترها را شلوغ می کند */}
              {/* <Col md={2} xs={6} className='form-group'>
                <input className='tableRowInput' name="StopDesc" ref={register({})} defaultValue={filterData?.StopDesc ?? ""} placeholder='شرح توقف' />
              </Col> */}
              {!isMobile &&
                <Col md={2} xs={6} className='form-group'>
                  <select className='tableRowInput' name="SortOrder" ref={register({})} defaultValue={filterData?.SortOrder ?? ""}>
                    <option value="" style={{ color: "gray" }}>مرتب سازی بر اساس</option>
                    <option value="UPDATE DESC">آخرین تغییر</option>
                    <option value="CONTACT">تاریخ پذیرش</option>
                    <option value="CONTACT DESC">تاریخ پذیرش-نزولی</option>
                    <option value="NUMBER">شماره سرویس</option>
                    <option value="NUMBER DESC">شماره سرویس-نزولی</option>
                    <option value="HOLDER">مارک محصول</option>
                    <option value="HOLDER DESC">مارک محصول-نزولی</option>
                    <option value="PNAME">نام/نوع محصول</option>
                    <option value="PNAME DESC">نام/نوع محصول-نزولی</option>
                    <option value="PMODEL">مدل محصول</option>
                    <option value="PMODEL DESC">مدل محصول-نزولی</option>
                    <option value="CUST">نام مشتری</option>
                    <option value="CUST DESC">نام مشتری-نزولی</option>
                  </select>
                </Col>
              }
              <Col md={2} xs={6} className='form-group'>
                <select className='tableRowInput' name="Take" ref={register({})} defaultValue={filterData?.Take ?? "10"}>
                  <option value="0">تعداد در صفحه</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </Col>
            </Row>

            <div className='mt-1' style={{ textAlign: "right" }}>
              <Button className='group-Btn' type="submit"><Search size={15} />&nbsp;جستجوی سرویس ها&nbsp;</Button>
              <Button variant='secondary' className='group-Btn' onClick={getWatingList}><CardList size={15} />&nbsp;فهرست انتظار</Button>
            </div>
          </form>
          {!pending &&
            <div style={{ padding: 0, width: "100%", textAlign: "left" }}>
              <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
              <Printer onClick={printReport} size={25} style={{ cursor: "pointer" }} className="hoverIcon" color='blue' />
            </div>}
          {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
          <BihamtaTable columns={tableCols} rowButtons={tableRowButtons} filterData={filterData} rowClick={showService} maxHeight={500} className='mb-0 mt-0'
            searchMethod={(data) => dispatch(getMyTaskList(data))} reducerName="task" objectName="myTasks" hasPaging={true} style={{ whiteSpace: "nowrap" }} searchable />
        </div>
      </div>
    </div>
  )
}
export default MyTasks;
